let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("83J76")).then(() => parcelRequire('cB3cF'));